import React, { Component } from "react";
import "./index.scss";

class NotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="wap">
        <img
          className=""
          src={require("./img/403.png")}
          width="456"
          height="262"
          alt="404"
        />
        <div className="mes">
          <h1 style={{ fontSize: 72 }}>404</h1>
          <p className="text-info-color">抱歉，你无权访问该页面</p>
        </div>
      </div>
    );
  }
}

export default NotFound;
